import React from 'react';
import cx from 'classnames';
import { Answers, ChoiceField } from './types/form';
import iconsSvg from '../../images/icons.svg';

type ChoiceFieldQuestionProps = {
    answer?: string;
    field: ChoiceField;
    setAnswers: React.Dispatch<React.SetStateAction<Answers>>;
    id:
        | 'area'
        | 'house_age'
        | 'house_type'
        | 'house_isolation'
        | 'energy_source'
        | 'heating_type';
    icons?: { [key: string]: string };
};

export default function ChoiceFieldQuestion({
    answer = undefined,
    field,
    setAnswers,
    id,
    icons = undefined,
}: ChoiceFieldQuestionProps) {
    return (
        <>
            {field.choices.map((choice) => {
                if (!choice.value) return null;

                return (
                    <li
                        className={cx('form-option ', {
                            'form-option--icon': icons && icons[choice.value],
                        })}
                        key={`list-item-${choice.value}`}
                    >
                        <input
                            key={`button-area-${choice.value}`}
                            className="required form-option__input"
                            id={choice.value}
                            type="radio"
                            name={id}
                            value={choice.value}
                            onClick={() =>
                                setAnswers((prev) => ({
                                    ...prev,
                                    [id]: choice.value,
                                }))
                            }
                            defaultChecked={choice.value === answer}
                        />
                        <label
                            className={cx('form-option__label', {
                                'form-option__label--full': !(
                                    icons && icons[choice.value]
                                ),
                            })}
                            htmlFor={choice.value}
                        >
                            <span
                                className={cx('form-option__text', {
                                    'form-option__text--large': !(
                                        icons && icons[choice.value]
                                    ),
                                })}
                            >
                                {choice.display_name}
                            </span>
                            {icons && (
                                <span className="form-option__icon-wrapper">
                                    <svg className="form-option__icon">
                                        <use
                                            href={`${iconsSvg}#${icons[choice.value]}`}
                                        />
                                    </svg>
                                </span>
                            )}
                        </label>
                    </li>
                );
            })}
        </>
    );
}
